__webpack_require__.v = function(exports, wasmModuleId, wasmModuleHash, importsObj) {

	var req = fetch(__webpack_require__.p + "" + wasmModuleHash + ".module.wasm");
	var fallback = function() { return req
		.then(function(x) { return x.arrayBuffer(); })
		.then(function(bytes) { return WebAssembly.instantiate(bytes, importsObj); })
		.then(function(res) { return Object.assign(exports, res.instance.exports); }); };
	return req.then(function(res) {
		if (typeof WebAssembly.instantiateStreaming === "function") {

			return WebAssembly.instantiateStreaming(res, importsObj)
				.then(
					function(res) { return Object.assign(exports, res.instance.exports); },
					function(e) {
						if(res.headers.get("Content-Type") !== "application/wasm") {
							console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);
							return fallback();
						}
						throw e;
					}
				);
		}
		return fallback();
	});
};